import { isDev } from "./isDev.js";
function registerTidalVersion(tidalName, tidalVersion) {
  const __DEV__ = isDev();
  try {
    if (typeof globalThis.window === "undefined") return;
    if (tidalName && tidalVersion) {
      window.tidal ??= { packages: {} };
      window.tidal.packages[tidalName] = tidalVersion;
      if (__DEV__) {
        console.debug(`[tidal] registering ${tidalName}@${tidalVersion}`);
      }
    }
  } catch (_e) {
  }
}
export {
  registerTidalVersion
};
//# sourceMappingURL=registerTidalVersion.js.map
